export default __webpack_public_path__ + "static/media/park_linowy_regulamin_zal_1_2.9f6ae058.doc";